import apiAgent from '../api/agentAPI';

const getDownlineWithCommissionForYear = async (fromAgentId, agentId, year) => {
    return await apiAgent.getDownlineWithCommissionForYear(fromAgentId, agentId, year);
};

const getUplineWithCommissionForYear = async (agentId, year) => {
    return await apiAgent.getUplineWithCommissionForYear(agentId, year);
};

const search = async (fromAgentId, name, branch, group, level) => {
    return await apiAgent.search(fromAgentId, name, branch, group, level);
};

const profile = async id => {
    return await apiAgent.profile(id);
};

const commissionForYear = async (agentId, year) => {
    return await apiAgent.commissionForYear(agentId, year);
};

const groupCommissionForYear = async (agentId, year) => {
    return await apiAgent.groupCommissionForYear(agentId, year);
};

const payoutForYear = async (agentId, year) => {
    return await apiAgent.payoutForYear(agentId, year);
};

const singleSignon = async secretKey => {
    return await apiAgent.singleSignon(secretKey);
};

const getAccessibleBranch = async agentId => {
    return await apiAgent.getAccessibleBranch(agentId);
}

const tripRewards = async agentId => {
    return await apiAgent.tripRewards(agentId);
}

const rankingByBranch = async (year, type) => {
    return await apiAgent.rankingByBranch(year, type);
}

const rankingByGroup = async (year, type) => {
    return await apiAgent.rankingByGroup(year, type);
}

const rankingByAgent = async (year, type) => {
    return await apiAgent.rankingByAgent(year, type);
}

const rankingAgentByBranch = async (year, type) => {
    return await apiAgent.rankingAgentByBranch(year, type);
}

const rankingAgentByGroup = async (year, branch, type) => {
    return await apiAgent.rankingAgentByGroup(year, branch, type);
}

const myPerformance = async (agentId, years = null ) => {
    return await apiAgent.myPerformance(agentId, years);
}

const getCompletedSalesByBranchGroup = async (agentID, DateRangeParams) => {
    return await apiAgent.getCompletedSalesByBranchGroup(agentID, DateRangeParams);
}

const getAgentCompletedSalesByDate = async (agentID, DateRangeParams, Group, BranchID) => {
    return await apiAgent.getAgentCompletedSalesByDate(agentID, DateRangeParams, Group, BranchID);
}

const getAgentCompletedSalesByCaseType = async (agentID, DateRangeParams, Group, BranchID, caseType) => {
    return await apiAgent.getAgentCompletedSalesByCaseType(agentID, DateRangeParams, Group, BranchID, caseType);
}

const getAgentCompletedSalesBySalesDate = async (agentID, DateRangeParams, CaseType) => {
    return await apiAgent.getAgentCompletedSalesBySalesDate(agentID, DateRangeParams, CaseType);
}

const getTotalAgentRecruitListBy = async (agentID, DateRangeParams, Group, BranchID) => {
    return await apiAgent.getTotalAgentRecruitListBy(agentID, DateRangeParams, Group, BranchID);
}

const getTop10CompletedSalesByDate = async (agentID, DateRangeParams) => {
    return await apiAgent.getTop10CompletedSalesByDate(agentID, DateRangeParams);
}

const getAgentCompletedSalesListingByDate = async (agentID, DateRangeParams) => {
    return await apiAgent.getAgentCompletedSalesListingByDate(agentID, DateRangeParams);
}

const getTotalSalesCommissionPayoutByDate = async (agentID, DateRangeParams) => {
    return await apiAgent.getTotalSalesCommissionPayoutByDate(agentID, DateRangeParams);
}

const getAgentSalesCommissionPayoutListingByDate = async (agentID, DateRangeParams) => {
    return await apiAgent.getAgentSalesCommissionPayoutListingByDate(agentID, DateRangeParams);
}

const getCompletedSalesCommissionByYear = async (agentID, DateRangeParams) => {
    return await apiAgent.getCompletedSalesCommissionByYear(agentID, DateRangeParams);
}

const getNewHireSummaryByYear = async (agentID, DateRangeParams) => {
    return await apiAgent.getNewHireSummaryByYear(agentID, DateRangeParams);
}

const getCompletedSalesCommissionByMonthly = async (agentID, DateRangeParams) => {
    return await apiAgent.getCompletedSalesCommissionByMonthly(agentID, DateRangeParams);
}

const getTopAgentCompletedSalesByBranch = async (agentID, DateRangeParams) => {
    return await apiAgent.getTopAgentCompletedSalesByBranch(agentID, DateRangeParams);
}

const getTopRankingCompletedSalesByMonth = async (agentID, DateRangeParams) => {
    return await apiAgent.getTopRankingCompletedSalesByMonth(agentID, DateRangeParams);
}

const getCompletedSalesDetailsByAgentID = async (agentID, DateRangeParams) => {
    return await apiAgent.getCompletedSalesDetailsByAgentID(agentID, DateRangeParams);
}

const getHierarchyLevelList = async (agentId, branch, group) => {
    return await apiAgent.getHierarchyLevelList(agentId, branch, group);
}

const expose = {
    getDownlineWithCommissionForYear,
    getUplineWithCommissionForYear,
    search, profile,
    commissionForYear, groupCommissionForYear, payoutForYear,
    singleSignon,
    getAccessibleBranch,
    tripRewards,
    rankingByBranch,
    rankingByGroup,
    rankingByAgent,
    rankingAgentByBranch,
    rankingAgentByGroup,
    myPerformance,
    getCompletedSalesByBranchGroup,
    getAgentCompletedSalesByDate,
    getAgentCompletedSalesByCaseType,
    getAgentCompletedSalesBySalesDate,
    getTotalAgentRecruitListBy,
    getTop10CompletedSalesByDate,
    getAgentCompletedSalesListingByDate,
    getTotalSalesCommissionPayoutByDate,
    getAgentSalesCommissionPayoutListingByDate,
    getCompletedSalesCommissionByYear,
    getNewHireSummaryByYear,
    getCompletedSalesCommissionByMonthly,
    getTopAgentCompletedSalesByBranch,
    getTopRankingCompletedSalesByMonth,
    getCompletedSalesDetailsByAgentID,
    getHierarchyLevelList
};
export default expose;